import styled from "styled-components";

export const InvestorRegistrationDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0d039c;
  min-height: 100vh;

  .inner-container {
    /* margin-top:50px; */
    /* background-color:red; */
  }
  .main-content {
    text-align: start;
    button {
      background: #e61f01;
      border: none;
    }
  }
`;
